import LevelBase from "./levelBase";
import { Enemy, Exit, Interactive, Player } from "../objects";
import dbManager from "../../utils/dbManager";
import UI from "../UI";
import { SCALE, TICK_TIME } from "../../utils/constants";
import { translate } from "../../utils/localization";
import template from "lodash.template";

class Level16 extends LevelBase {
  constructor() {
    super();
    this.name = "The sanctuary";
    this.diamondsGoal = 25;
    // flag for alternative exit do not take effect until player go out and in again
    this.wasInSanctuary = false;
    // falg for dialogs
    this.maryTalkedToDocAboutTheSactuary = false;
    this.quakeTrigger = null;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    // ====================
    // sanctuary decoration
    // ====================
    // shadow text for SHAMASH
    this.scene.add
      .text(
        UI.tileToScreen(this.follower.position.x - 0.3),
        UI.tileToScreen(this.follower.position.y + 2.5),
        "𒀭𒌓",
        {
          fontFamily: "GameGirl",
          fill: "#503F35",
          align: "right",
        }
      )
      .setScale(SCALE);
    // text for SHAMASH
    this.scene.add
      .text(
        UI.tileToScreen(this.follower.position.x - 0.25),
        UI.tileToScreen(this.follower.position.y + 2.55),
        "𒀭𒌓",
        {
          fontFamily: "GameGirl",
          fill: "#947E6C",
          align: "right",
        }
      )
      .setScale(SCALE);
    if (this.unfinished) {
      this.follower.isFollowing = false;
      this.destroyBlock = () => false;
      this.follower.animLayRight();
    } else {
      // ============================
      // manually applys quake effect
      // ============================

      // removes debris
      const removeDebris = (x, y) => {
        let debris = this.getObjectAt(x, y);
        debris.overrunBy();
        this.replaceByEmpty(debris);
      };
      removeDebris(
        this.quakeTrigger.position.x - 1,
        this.quakeTrigger.position.y + 1
      );
      removeDebris(
        this.quakeTrigger.position.x - 2,
        this.quakeTrigger.position.y + 1
      );
      removeDebris(
        this.quakeTrigger.position.x - 3,
        this.quakeTrigger.position.y + 1
      );

      // removes ground
      const removeGround = (x, y) => {
        let ground = this.getObjectAt(x, y);
        ground.overrunBy();
        this.replaceByEmpty(ground);
      };
      removeGround(
        this.quakeTrigger.position.x + 1,
        this.quakeTrigger.position.y - 1
      );
      removeGround(
        this.quakeTrigger.position.x + 2,
        this.quakeTrigger.position.y - 1
      );

      // ============
      // removes NPCs
      // ============
      this.follower.alien.destroy();
      this.follower = null;
      this.replaceByEmpty(this.leader);
      this.leader.alien.destroy();
      this.leader = null;

      // ================================
      // removes usless interactive spots
      // ================================
      Object.keys(this.interactiveElements).forEach(
        (k) => {
          // removes if is not the exit
          if(!this.interactiveElements[k].isClass(Exit)) {
            this.interactiveElements[k] = null
          }
        }
      );
      // this.interactiveElements[`${this.quakeTrigger.position.x}-${this.quakeTrigger.position.y}`] = null
      // this.quakeTrigger.
    }
  }

  onInteractWith(el) {
    super.onInteractWith(el);

    if (el.isClass(Exit)) {
      if (this.unfinished) {
        this.goToSanctuary();
      } else {
        this.onComplete();
      }
    }

    // earthquake triggers
    if (el.isClass(Interactive) && el.order === 0) {
      this.playTheSighting(el);
    }
    // talk to dwarf
    if (el.isClass(Interactive) && el.order === 2) {
      const goalAchieved = this.collectedDiamonds >= this.diamondsGoal;
      // removes interactive object since goal is achived
      if (goalAchieved) {
        this.interactiveElements[`${el.position.x}-${el.position.y}`] = null;
      }

      if (!this.maryTalkedToDocAboutTheSactuary) {
        this.showDialog2();
      } else {
        this.showDialog2_repeat();
      }
    }
    // sanctuary exit
    if (el === this.sanctuaryEntrance && this.wasInSanctuary) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if (el.isClass(Enemy)) {
      el.scanDirection = "CCW";
    }

    if (el.isClass(Interactive) && el.order === 2) {
      el.ephemeral = false;
    }

    // quake trigger
    if (el.isClass(Interactive) && el.order === 0) {
      this.quakeTrigger = el;
    }
    // enter to the sanctuary
    if (el.isClass(Interactive) && el.order === 1) {
      el.ephemeral = false;
      this.sanctuaryEntrance = el;
    }

    // add sanctuary entrance by clonning exit
    if (el.isClass(Exit) && this.unfinished) {
      const layer1z2 = this.scene.children.getByName("layer_1z2");
      const layer2 = this.scene.children.getByName("layer_2");
      layer2.copy(
        el.position.x - 2,
        el.position.y - 2,
        5,
        5,
        this.sanctuaryEntrance.position.x - 2,
        this.sanctuaryEntrance.position.y - 2
      );
      layer1z2.copy(
        el.position.x - 2,
        el.position.y - 2,
        5,
        5,
        this.sanctuaryEntrance.position.x - 2,
        this.sanctuaryEntrance.position.y - 2
      );
    }
  }

  async playTheSighting() {
    this.player.disconnect();
    await this.playEarthquake(
      {
        x1: this.player.position.x - 3,
        x2: this.player.position.x + 3,
        y1: this.player.position.y - 1,
        y2: this.player.position.y + 2,
      },
      4
    );
    await this.awaitTicks(10);
    this.player.animPushRight();
    await this.awaitTicks(4);
    this.player.animPushRight();
    this.onNextTick(() => this.player.animPushRight());
    await this.awaitTicks(4);
    await this.showDialog1();
    this.player.reconnect();
  }

  showDialog1() {
    return new Promise((res) => {
      this.scene.events.once("dialogue:hidden", res);
      this.scene.events.emit("dialogue:show", {
        participants: ["closeUp_Mary"],
        participantNames: ["Mary"],
        conversation: [
          {
            who: "closeUp_Mary",
            text: [translate("level_16.dialog_1.mary_say_1")],
          },
          {
            who: "closeUp_Mary",
            text: [translate("level_16.dialog_1.mary_say_2")],
          },
          {
            who: "closeUp_Mary",
            text: [translate("level_16.dialog_1.mary_say_3")],
          },
        ],
      });
    });
  }

  showDialog2() {
    this.maryTalkedToDocAboutTheSactuary = true;
    const goalAchieved = this.collectedDiamonds >= this.diamondsGoal;
    this.scene.events.once("dialogue:hidden", () => {
      if (goalAchieved) {
        this.moveToExit();
      }
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_16.dialog_2.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_16.dialog_2.dwarf_say_1")],
          options: {
            slot2: {
              label: translate("menu.dialog_options.next"),
              slot: 2,
              onSelect: () => {
                if (this.collectedDiamonds < this.diamondsGoal) {
                  this.scene.events.emit("dialogue:nextPage");
                } else {
                  this.scene.events.emit("dialogue:nextPage", 1);
                }
              },
            },
          },
        },
        {
          who: "closeUp_Dwarf",
          text: [
            template(translate("level_16.dialog_2.dwarf_say_2_diamonds"))({
              NUM: this.diamondsGoal,
            }),
          ],
          options: {
            slot2: null,
          },
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_16.dialog_2.mary_say_2")],
        },
      ],
    });
  }
  showDialog2_repeat() {
    const goalAchieved = this.collectedDiamonds >= this.diamondsGoal;
    this.scene.events.once("dialogue:hidden", () => {
      if (goalAchieved) {
        this.moveToExit();
      }
    });
    const goalAchievedConversation = {
      who: "closeUp_Mary",
      text: [translate("level_16.dialog_2_repeat.mary_say_1")],
    };
    const goalMissingConversation = {
      who: "closeUp_Dwarf",
      text: [
        template(translate("level_16.dialog_2_repeat_no_diamonds.dwarf_say_1"))(
          { NUM: this.diamondsGoal }
        ),
      ],
    };
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        goalAchieved ? goalAchievedConversation : goalMissingConversation,
      ],
    });
  }

  async moveToExit() {
    this.dwarfRun = true;
    this.leader.leadingPath = [
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
    ];

    // anim angel dismiss
    this.scene.tweens.add({
      targets: this.exit.block.alien,
      x: UI.tileToScreen(this.exit.position.x),
      duration: TICK_TIME * 2,
      onComplete: () => {
        this.exit.block.alien.destroy();
      },
    });

    // removes exit to avoid dwarf been destroyed on interact with it
    this.interactiveElements[
      `${this.exit.position.x}-${this.exit.position.y}`
    ] = null;
    this.exit.setPosition({
      x: this.exit.position.x + 1,
      y: this.exit.position.y,
    });

    this.moveDwarf();
    await this.awaitTicks(this.leader.leadingPath.length);
    await this.teleportObject(this.leader, this.sanctuaryEntrance.position);

    // restores exit
    this.exit.setPosition({
      x: this.exit.position.x - 1,
      y: this.exit.position.y,
    });
    this.interactiveElements[
      `${this.exit.position.x}-${this.exit.position.y}`
    ] = this.exit;
  }

  moveDwarf() {
    // hack to auto move dwarf until pos x is 10
    if (this.dwarfRun) {
      // if (this.leader.position.x < this.exit.position.x) {
      if (this.leader.leadingPath.length) {
        this.onNextTick(() => {
          this.leader.onPlayerMoves(this.leader.position);
          // this.leader.animIdle();
          this.moveDwarf();
        });
      } else {
        this.dwarfRun = false;
        this.leader.animIdle();
      }
    }
  }
  movePlayer() {
    if (this.playerRun) {
      this.onNextTick(() => {
        if (this.player.moveToNextPosition()) {
          this.movePlayer();
        } else {
          this.playerRun = false;
        }
      });
    }
  }

  async goToSanctuary() {
    this.player.disconnect();

    this.focusElement = {
      position: this.sanctuaryEntrance.position,
    };
    await this.awaitTicks(7);
    this.follower.alien.alpha = 0;
    await this.teleportObject(this.player, this.sanctuaryEntrance.position);

    this.player.mandatoryPath = [
      {
        x: this.sanctuaryEntrance.position.x - 1,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 2,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 3,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 4,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 5,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 6,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 7,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 8,
        y: this.sanctuaryEntrance.position.y,
      },
    ];

    this.playerRun = true;
    this.movePlayer();

    // delay dwarf run so they keep 1 sapce bewteen
    await this.awaitTicks(1);
    this.leader.leadingPath = [
      {
        x: this.sanctuaryEntrance.position.x - 1,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 2,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 3,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 4,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 5,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 6,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 7,
        y: this.sanctuaryEntrance.position.y,
      },
    ];
    this.dwarfRun = true;
    this.moveDwarf();

    await this.awaitTicks(this.leader.leadingPath.length);
    await this.awaitTicks(3);
    this.showDialog3();
  }

  async moveDocToFinalExit() {
    this.leader.leadingPath = [
      {
        x: this.sanctuaryEntrance.position.x,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 1,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 2,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 3,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 4,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 5,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 6,
        y: this.sanctuaryEntrance.position.y,
      },
      {
        x: this.sanctuaryEntrance.position.x - 7,
        y: this.sanctuaryEntrance.position.y,
      },
    ].reverse();
    this.dwarfRun = true;
    this.moveDwarf();

    await this.awaitTicks(this.leader.leadingPath.length + 2);
    this.leader.alien.destroy();
    this.leader.alien = null;
    this.replaceByEmpty(this.leader);
  }

  showDialog3() {
    this.scene.events.once("dialogue:hidden", async () => {
      this.wasInSanctuary = true;
      await this.moveDocToFinalExit();
      this.player.reconnect();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_16.dialog_3.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_16.dialog_3.dwarf_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_16.dialog_3.dwarf_say_2")],
        },
      ],
    });
  }
}

Level16.key = "level_16";
export default Level16;
